import Banner from "../components/Banner";
import Card from "../components/Card";
import Experts from "../components/Experts";
import NewsLetter from "../components/NewsLetter";

function HomePage() {
    return (
        <div className='HomePage'>

            {/* Banner */}
            <Banner />

            {/* Expert */}
            <Experts />

            {/* NewsLetter */}
            <NewsLetter />

            {/* Pricing Card */}
            <Card />

        </div>
    )
}

export default HomePage